export const GOOGLE_AUTH_CREATE_PASSWORD_MODAL = 'GOOGLE_AUTH_CREATE_PASSWORD_MODAL';
export const GOOGLE_AUTH_CREATE_PASSWORD_FORM = 'GOOGLE_AUTH_CREATE_PASSWORD_FORM';
